import { useLang } from "@/i18n";

const GOLD = "#C2A675";
const BONE = "#F9F8F3";

/* Schéma de profil : le principe d'assise Adirondack appliqué au jacuzzi */
export default function AdirondackSchema() {
  const { t } = useLang();

  return (
    <div
      data-testid="jacuzzi-schema"
      className="w-full aspect-[4/3] border gold-hairline bg-moss/30 p-3 flex flex-col"
    >
      <svg viewBox="0 0 400 260" className="w-full h-full" role="img" aria-label={t.jacuzzi.schemaCaption}>
        {/* terrasse */}
        <line x1="24" y1="228" x2="376" y2="228" stroke={GOLD} strokeOpacity="0.3" strokeWidth="1" />

        {/* regard vers l'horizon */}
        <line x1="130" y1="70" x2="356" y2="70" stroke={GOLD} strokeOpacity="0.45" strokeWidth="1" strokeDasharray="3 5" />
        <path d="M 350 78 q 7 -4 14 0 q 7 4 14 0" fill="none" stroke={GOLD} strokeOpacity="0.5" strokeWidth="1.2" />
        <text x="196" y="60" className="font-mono" fill={BONE} fillOpacity="0.75" fontSize="8.5" letterSpacing="1.5">
          {t.jacuzzi.schemaGaze}
        </text>

        {/* chaise — profil */}
        <g stroke={GOLD} strokeWidth="2.5" strokeLinecap="round">
          {/* dossier incliné */}
          <line x1="150" y1="188" x2="95" y2="78" />
          {/* assise : hanches basses, genoux hautes */}
          <line x1="148" y1="190" x2="246" y2="178" />
          {/* accoudoir + support */}
          <line x1="162" y1="148" x2="258" y2="144" />
          <line x1="252" y1="145" x2="255" y2="177" />
          {/* pieds */}
          <line x1="152" y1="228" x2="148" y2="191" />
          <line x1="243" y1="228" x2="246" y2="179" />
        </g>

        {/* silhouette assise (abstraite) */}
        <g stroke={BONE} strokeOpacity="0.9" strokeWidth="2.5" strokeLinecap="round" fill="none">
          <circle cx="117" cy="76" r="11" />
          <path d="M 152 184 L 122 96" />
          <path d="M 152 184 L 222 172 L 230 227" />
        </g>

        {/* angle 110° */}
        <path d="M 184 184 A 34 34 0 0 0 138 159" fill="none" stroke={GOLD} strokeWidth="1.2" />
        <text x="192" y="166" className="font-mono" fill={GOLD} fontSize="11" letterSpacing="1">
          {t.jacuzzi.schemaAngle}
        </text>

        {/* hanches sous les genoux */}
        <line x1="152" y1="172" x2="300" y2="172" stroke={GOLD} strokeOpacity="0.4" strokeWidth="1" strokeDasharray="3 5" />
        <text x="256" y="166" className="font-mono" fill={BONE} fillOpacity="0.75" fontSize="8.5" letterSpacing="1.5">
          {t.jacuzzi.schemaHip}
        </text>

        {/* eau du jacuzzi en bas */}
        <path d="M 24 246 q 12 -5 24 0 t 24 0 t 24 0 t 24 0 t 24 0" fill="none" stroke={GOLD} strokeOpacity="0.35" strokeWidth="1.2" />
      </svg>
      <p className="font-mono text-[0.55rem] uppercase tracking-[0.2em] text-sage text-center leading-relaxed mt-1">
        {t.jacuzzi.schemaCaption}
      </p>
    </div>
  );
}
